<template>
  <div class="container-fluid">
    <Loading v-if="this.isLoading()" />
    <AlertDialog v-if="this.isAlertDialog()" />
    <div class="row header bt-primary justify-content-between align-items-center">
      <div class="col-auto">
        <img
          class="titleimg"
          src="@/assets/acrypro/ambi_logo.png"
          width="100px"
          style="cursor: pointer"
          @click="backhome"
        />
      </div>
      <div class="col-auto">
        <a href="#" class="text-dark me-3" style="text-decoration: none">お問い合わせ</a>
      </div>
    </div>
    <div class="row" style="height: 70px"></div>
    <div class="row">
      <div class="col text-center">
        <p class="noto acry-foreground h2 fw-bold">ACRY PROに新規登録</p>
      </div>
    </div>
    <template v-if="isEnd == false">
      <form>
        <div class="row mt-4 justify-content-center">
          <div class="col-auto text-start">
            <h4 class="textcolor text-start" style="font-size: 15px">メールアドレス</h4>
            <input
              type="email"
              class="input border border-1 border-gray rounded mt-1 acry-input"
              v-model="email"
              v-on:keydown.enter="registAction"
              placeholder="メールアドレス"
            />
            <p v-if="isMailError" class="mt-3 ms-2 text-danger">
              メールアドレスが正しくありません
            </p>
          </div>
          <div class="row mt-3 justify-content-center">
            <div class="col-auto">
              <h4 class="textcolor text-start" style="font-size: 15px">パスワード</h4>
              <input
                type="password"
                class="input border border-1 border-gray rounded acry-input"
                v-model="password"
                v-on:keydown.enter="registAction"
                placeholder="6文字以上の半角英数字"
              />
              <p v-if="isPasswordError" class="mt-3 text-danger">
                パスワードは6文字以上入力してください
              </p>
            </div>
          </div>

          <div class="row justify-content-center mt-4">
            <div class="col-12 mt-2">
              <button
                type="button"
                class="registbtn acry-background"
                @click="this.registAction"
              >
                <h5 class="mt-2 fw-bold">登録</h5>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-if="isEnd">
      <div class="row ps-3">
        <p>メールアドレス確認用メールを送信しました。</p>
        <br />
        <p>メールをご確認いただき認証を完了お願いします。</p>
      </div>
    </template>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
import "firebase/analytics";
import "firebase/functions";
import AlertDialog from "@/components/acyrpro/modal/dialog/AlertDialog_Ap.vue";
import Loading from "@/components/modal/dialog/Loading.vue";
import { Common } from "@/js/common.js";
import router from "../router";
import { User } from "@/js/User.js";
import { Analytics } from "@/js/Analytics.js";
// import router from '../router';

export default {
  name: "AcryProRegistMailAddress",
  components: { AlertDialog, Loading },
  props: {},
  data() {
    return {
      email: "",
      password: "",
      isEnd: false,
      isPasswordError: false,
      isMailError: false,
    };
  },
  watch: {
    email() {
      this.isMailError = false;
    },
    password() {
      this.isPasswordError = false;
    },
  },
  created() {},
  methods: {
    backhome() {
      router.push("/");
    },
    async createAccount() {

      let isError = false;

      // Firebaseのアカウントを作成
      await firebase.auth().createUserWithEmailAndPassword(this.email, this.password).catch((error) => {
        isError = true;
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", Common.fbmessageToJp(error));
      });
      if( isError ) return;

      await User.authPartnerCode("XXXXXXXX").catch( (e)=>{
        isError = true;
        this.$handleError("070", e, { hideLoading: true });
      });
      if( isError ) return;

      await User.sendVerificationEmail(this.email).catch( (e)=>{
        isError = true;
        this.$handleError("071", e, { hideLoading: true });
      });
      if( isError ) return;

      // 新規登録
      Analytics.signUp("email");
      Analytics.setUserId(firebase.auth().currentUser.uid);

      await firebase.auth().signOut();
      this.$store.commit("setAlertDialogCallback", this.pushAction);
      this.$store.commit(
        "showMessage",
        "確認のメールを送信しました\nメールをご確認いただき認証を完了お願いします。"
      );
    },
    pushAction() {
      router.push("/");
    },
    registAction() {
      // 入力チェック
      if (this.password.length < 6) {
        this.isPasswordError = true;
      }
      if (Common.isInValidEmail(this.email)) {
        this.isMailError = true;
      }
      if (this.isPasswordError || this.isMailError) {
        return;
      }

      this.$store.commit("showLoading");
      this.createAccount();
    },
    isAlertDialog() {
      return this.$store.state.isAlertDialog;
    },
    isLoading() {
      return this.$store.state.isLoading;
    },
  },
};
</script>

<style scoped>
.registbtn {
  color: white;
  width: 320px;
  height: 62px;
  vertical-align: middle;
  border-radius: 32px;
  border: none;
}
.registbtn :hover {
  color: white;
}
.acry-input {
  width: 320px;
  height: 48px;
  padding-left: 10px;
}

@media (max-width: 480px) {
  .registbtn,
  .acry-input {
    width: 88vw;
    max-width: 320px;
  }
}
</style>
